"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _eventIcons = _interopRequireDefault(require("./eventIcons"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = {
  PROJECT_BRIEF_CREATED: {
    name: 'PROJECT_BRIEF_CREATED',
    resourceType: 'VIDEO',
    message: 'New Project created',
    icon: _eventIcons["default"].PROJECTS
  },
  PROJECT_BRIEF_SUBMITTED: {
    name: 'PROJECT_BRIEF_SUBMITTED',
    resourceType: 'VIDEO',
    message: 'Submitted for {status}',
    icon: _eventIcons["default"].PROJECTS,
    requiredFields: ['status']
  },
  PROJECT_BRIEF_REJECTION: {
    name: 'PROJECT_BRIEF_REJECTION',
    resourceType: 'VIDEO',
    message: 'Changes requested in {status}',
    icon: _eventIcons["default"].PROJECTS,
    requiredFields: ['rejectionReason', 'status']
  },
  PROJECT_BRIEF_APPROVAL: {
    name: 'PROJECT_BRIEF_APPROVAL',
    resourceType: 'VIDEO',
    message: '{status} approved',
    icon: _eventIcons["default"].PROJECTS,
    requiredFields: ['status']
  },
  PROJECT_BRIEF_OWNER_CHANGED: {
    name: 'PROJECT_BRIEF_OWNER_CHANGED',
    resourceType: 'VIDEO',
    message: 'Project owner changed to {ownerName}',
    icon: _eventIcons["default"].PROJECTS,
    requiredFields: ['ownerId']
  },
  PROJECT_TRANSFER_OWNERSHIP: {
    name: 'PROJECT_TRANSFER_OWNERSHIP',
    resourceType: 'VIDEO',
    message: 'Project ownership has been transferred',
    icon: _eventIcons["default"].PROJECTS,
    requiredFields: ['source', 'destination']
  },
  PROJECT_OUTPUT_EDITOR_ASSIGNED: {
    name: 'PROJECT_OUTPUT_EDITOR_ASSIGNED',
    resourceType: 'VIDEO_OUTPUT',
    message: '{editorName} (Editor) has been assigned',
    icon: _eventIcons["default"].SHOOTSTAGRAD,
    requiredFields: ['editorId']
  },
  PROJECT_OUTPUT_INTERNAL_SUBMITTED: {
    name: 'PROJECT_OUTPUT_INTERNAL_SUBMITTED',
    resourceType: 'VIDEO_OUTPUT',
    message: 'Submitted for internal review',
    icon: _eventIcons["default"].SHOOTSTAGRAD
  },
  PROJECT_OUTPUT_INTERNAL_REJECTION: {
    name: 'PROJECT_OUTPUT_INTERNAL_REJECTION',
    resourceType: 'VIDEO_OUTPUT',
    message: 'Version {version} rejected in Internal Review',
    icon: _eventIcons["default"].SHOOTSTAGRAD,
    requiredFields: ['rejectionReason', 'version']
  },
  PROJECT_OUTPUT_INTERNAL_APPROVED: {
    name: 'PROJECT_OUTPUT_INTERNAL_APPROVED',
    resourceType: 'VIDEO_OUTPUT',
    message: 'Version {version} approved in Internal Review',
    icon: _eventIcons["default"].SHOOTSTAGRAD,
    requiredFields: ['version']
  },
  PROJECT_OUTPUT_SUBMITTED: {
    name: 'PROJECT_OUTPUT_SUBMITTED',
    resourceType: 'VIDEO_OUTPUT',
    message: 'Submitted for {status}',
    icon: _eventIcons["default"].VIDEO,
    requiredFields: ['status']
  },
  PROJECT_OUTPUT_REJECTION: {
    name: 'PROJECT_OUTPUT_REJECTION',
    resourceType: 'VIDEO_OUTPUT',
    message: 'Changes requested in {status}',
    icon: _eventIcons["default"].VIDEO,
    requiredFields: ['status', 'rejectionReason', 'version']
  },
  PROJECT_OUTPUT_APPROVAL: {
    name: 'PROJECT_OUTPUT_APPROVAL',
    resourceType: 'VIDEO_OUTPUT',
    message: '{status} approved',
    icon: _eventIcons["default"].VIDEO,
    requiredFields: ['status']
  },
  PROJECT_OUTPUT_COMPLETED: {
    name: 'PROJECT_OUTPUT_COMPLETED',
    resourceType: 'VIDEO_OUTPUT',
    message: 'Completed',
    icon: _eventIcons["default"].VIDEO
  },
  PROJECT_OUTPUT_REOPENED: {
    name: 'PROJECT_OUTPUT_REOPENED',
    resourceType: 'VIDEO_OUTPUT',
    message: 'Re-opened for editing',
    icon: _eventIcons["default"].VIDEO
  },
  PROJECT_OUTPUT_AUTO_SUBMITTED: {
    name: 'PROJECT_OUTPUT_AUTO_SUBMITTED',
    resourceType: 'VIDEO_OUTPUT',
    message: 'Automatically submitted for editing by Shootsta',
    icon: _eventIcons["default"].SHOOTSTAGRAD
  },
  PROJECT_OUTPUT_ARCHIVED: {
    name: 'PROJECT_OUTPUT_ARCHIVED',
    resourceType: 'VIDEO_OUTPUT',
    message: 'Archived',
    icon: _eventIcons["default"].VIDEO
  },
  PROJECT_OUTPUT_DELETED: {
    name: 'PROJECT_OUTPUT_DELETED',
    resourceType: 'VIDEO_OUTPUT',
    message: 'Deleted',
    icon: _eventIcons["default"].VIDEO
  },
  PROJECT_OUTPUT_RESET_DRAFT: {
    name: 'PROJECT_OUTPUT_RESET_DRAFT',
    resourceType: 'VIDEO_OUTPUT',
    message: 'Moved back to building by Shootsta',
    icon: _eventIcons["default"].SHOOTSTAGRAD
  },
  PROJECT_OUTPUT_ADDONS: {
    name: 'PROJECT_OUTPUT_ADDONS',
    resourceType: 'VIDEO_OUTPUT',
    requiredFields: ['addons', 'version']
  },
  PROJECT_OUTPUT_APPLIED_ADDONS_COUNT: {
    name: 'PROJECT_OUTPUT_APPLIED_ADDONS_COUNT',
    resourceType: 'VIDEO_OUTPUT',
    message: '{appliedAddonsCount} New Add-ons applied',
    icon: _eventIcons["default"].VIDEO,
    requiredFields: ['appliedAddonsCount']
  },
  PROJECT_OUTPUT_CREDITS_ADJUSTED: {
    name: 'PROJECT_OUTPUT_CREDITS_ADJUSTED',
    resourceType: 'VIDEO_OUTPUT',
    message: 'Credits adjusted by Shootsta',
    requiredFields: ['creditDelta']
  },
  GHOST_TOKEN_REQUESTED: {
    name: 'GHOST_TOKEN_REQUESTED',
    resourceType: 'USER',
    message: 'Ghost token was requested',
    requiredFields: ['originalUserName', 'originalUserId', 'ghostUserName', 'ghostUserId']
  },
  PROJECT_OUTPUT_APPROVED_FOR_CAPTIONING: {
    name: 'PROJECT_OUTPUT_APPROVED_FOR_CAPTIONING',
    resourceType: 'VIDEO_OUTPUT',
    message: 'Approved for captioning'
  },
  PROJECT_OUTPUT_STORYBOARD_APPROVED: {
    name: 'PROJECT_OUTPUT_STORYBOARD_APPROVED',
    resourceType: 'VIDEO_OUTPUT',
    message: 'Storyboard approved'
  },
  STORYBOARD_CREATED: {
    name: 'STORYBOARD_CREATED',
    resourceType: 'STORYBOARD',
    message: 'New Storyboard created',
    icon: _eventIcons["default"].PROJECTS
  },
  STORYBOARD_REOPENED: {
    name: 'STORYBOARD_REOPENED',
    resourceType: 'STORYBOARD',
    message: 'Re-opened storyboard for editing',
    icon: _eventIcons["default"].PROJECTS
  },
  STORYBOARD_DELETED: {
    name: 'STORYBOARD_DELETED',
    resourceType: 'STORYBOARD',
    message: 'Storyboard deleted by {editorName}',
    icon: _eventIcons["default"].PROJECTS,
    requiredFields: ['editorId']
  },
  // Internal
  STORYBOARD_INTERNAL_SUBMITTED: {
    name: 'STORYBOARD_INTERNAL_SUBMITTED',
    resourceType: 'STORYBOARD',
    message: 'Submitted for internal review',
    icon: _eventIcons["default"].SHOOTSTAGRAD
  },
  STORYBOARD_INTERNAL_REJECTED: {
    name: 'STORYBOARD_INTERNAL_REJECTED',
    resourceType: 'STORYBOARD',
    message: 'Version {version} rejected in Internal Review',
    icon: _eventIcons["default"].SHOOTSTAGRAD,
    requiredFields: ['version']
  },
  STORYBOARD_INTERNAL_APPROVED: {
    name: 'STORYBOARD_INTERNAL_APPROVED',
    resourceType: 'STORYBOARD',
    message: 'Version {version} approved in Internal Review',
    icon: _eventIcons["default"].SHOOTSTAGRAD,
    requiredFields: ['version']
  },
  // Client
  STORYBOARD_SUBMITTED: {
    name: 'STORYBOARD_SUBMITTED',
    resourceType: 'STORYBOARD',
    message: 'Submitted for Client Review',
    icon: _eventIcons["default"].PROJECTS,
    requiredFields: ['status']
  },
  STORYBOARD_REJECTED: {
    name: 'STORYBOARD_REJECTED',
    resourceType: 'STORYBOARD',
    message: 'Changes requested in Client Review',
    icon: _eventIcons["default"].PROJECTS,
    requiredFields: ['status']
  },
  STORYBOARD_APPROVAL: {
    name: 'STORYBOARD_APPROVAL',
    resourceType: 'STORYBOARD',
    message: 'Storyboard approved in Client Review',
    icon: _eventIcons["default"].PROJECTS,
    requiredFields: ['status']
  },
  EDITOR_VO_ADDON_SUBMITTED: {
    name: 'EDITOR_VO_ADDON_SUBMITTED',
    resourceType: 'VIDEO_OUTPUT',
    message: '{editorName} (Editor) Changed VoiceOverArtist Addons',
    requiredFields: ['addons', 'version']
  }
};
exports["default"] = _default;